<template>
  <div class="index-SharePoint">
    <div class="WEB-title col-24 no-padding">
      <span class="appname">
        {{ $t('SharePoint.title').toUpperCase() }}
      </span>
    </div>

    <div class="WEB-content WEB-box-shadow col-24 no-padding">
      <keep-alive>
        <router-view class="contenuto" :tableHeight="contenitoreHeight - 40"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contenitoreHeight: {
      type: Number
    }
  },
  name: 'IndexSP',
  components: {/*HeaderApp*/ },
  /*watch: {
    '$mq.resize': 'setContenitoreHeight'
  },*/
  i18n: {
    messages: {
      it_IT: {
        SharePoint: {
          title: 'Sistema di Gestione Documentale'
        }
      },
      fr_FR: {
        SharePoint: {
          title: 'Système de Gestion Documentaire'
        }
      },
      es_ES: {
        SharePoint: {
          title: 'Sistema di Gestione Documentale'
        }
      },
      de_DE: {
        SharePoint: {
          title: 'Sistema di Gestione Documentale'
        }
      },
      en_GB: {
        SharePoint: {
          title: 'Sistema di Gestione Documentale'
        }
      }
    }
  },
  data() {
    return {
      //contenitoreHeight: 0,
      //tableHeight: 0,
      //counterNuovi: 0
    }
  },
  mounted: function () {
    // this.$router.push({name: 'HomePage'})
    //this.setContenitoreHeight()
  },
  computed: {
    showIcone: function () {
      let path = this.$route.path
      return (path.indexOf('/trasferte/riepilogo') === 0)
    }
  },
  methods: {
    /*setContenitoreHeight: function () {
      console.log('size')
      this.contenitoreHeight = window.innerHeight - 140
      this.tableHeight = this.contenitoreHeight - 155
    },
    goToNuova: function () {
      this.$router.push({name: 'NuovaTrasferta'})
    } */
  }
}
</script>

<style lang="less">
@import "../../assets/less/WEB-style.less";
@import "../../assets/less/general.less";

.index-SharePoint {
}
</style>



// WEBPACK FOOTER //
// src/components/SharePoint/IndexSharePoint.vue